import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { LeadForm } from '../components/LeadForm';
import { MarketStats } from '../components/MarketStats';
import { About } from '../components/About';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { FloatingVideo } from '../components/FloatingVideo';
import { Calculator } from '../components/Calculator';
import { CaseStudies } from '../components/CaseStudies';
import { useScreenInit } from '../useScreenInit';
export function LandingPage() {
  useScreenInit();
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-375">
      <Header data-id="element-376" />
      <main className="flex-grow" data-id="element-377">
        <Hero data-id="element-378" />
        <MarketStats data-id="element-379" />
        <Calculator data-id="element-380" />
        <CaseStudies data-id="element-381" />
        <LeadForm data-id="element-382" />
        <About data-id="element-383" />
        <FAQ data-id="element-384" />
      </main>
      <Footer data-id="element-385" />
      <FloatingVideo data-id="element-386" />
    </div>;
}